import { createSlotRecipe } from './runtime.mjs';

const menuConfig = {"name":"menu","className":"ds-menu","slots":["content","item","leading","label","trailing","hint","indicator","groupLabel","separator","switchTrack","switchThumb"]}

export const menu = /* @__PURE__ */ createSlotRecipe(menuConfig)